/**
 * Selector to access analytics data from the Redux state.
 */
export const analyticsSelector = (state) => state.analytics;
